import { Grid, Typography } from '@mui/material';
import CustomToggleButtonGroup from '../../../mini-components/CustomToggleButtonGroup';
import CustomTextField from './CustomTextField';
import { Controller } from 'react-hook-form';

const RoommateInfo = ({ register, control, errors }) => {
  return (
    <>
      <Grid item xs={12} sm={6}>
        <CustomTextField
          name="currentRoommates"
          label="Current Roommates"
          type="number"
          register={register}
          errors={errors}
          validation={{ valueAsNumber: true }}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <CustomTextField
          name="neededRoommates"
          label="Needed Roommates"
          type="number"
          register={register}
          errors={errors}
          validation={{ valueAsNumber: true }}
        />
      </Grid>

      <Grid item xs={12}>
        <CustomTextField
          name="contactInfo"
          label="Contact Info"
          required
          register={register}
          errors={errors}
          validation={{ required: 'Contact Info is required' }}
        />
      </Grid>

      <Grid item xs={12}>
        <Typography variant="subtitle1" gutterBottom sx={{ color: "#fff" }}>
          Roommate Should Have Gender <span style={{ color: "#ff6b6b" }}>*</span>
        </Typography>
        <Controller
          control={control}
          name="roommateShouldHaveGender"
          rules={{ required: 'Please select a gender' }}
          render={({ field }) => (
            <CustomToggleButtonGroup
              value={field.value}
              onChange={(event, newValue) => field.onChange(newValue)}
              options={[
                { label: 'Male', value: 'male' },
                { label: 'Female', value: 'female' },
                { label: 'Any', value: 'any' },
              ]}
            />
          )}
        />
      </Grid>
    </>
  );
};

export default RoommateInfo;
